module.exports = __webpack_public_path__ + "img/polygon_logo.a0f2d172.png";